// extracted by mini-css-extract-plugin
module.exports = {"description":"PostDetail_description__3u0Oz","applyBtn":"PostDetail_applyBtn__DOz5V"};